import React from 'react';
import {SketchPicker} from 'react-color';

export function ColorPicker({formik}) {
  const handleChange = updatedColor => {
    formik.setFieldValue('coverBgColor', updatedColor.hex);
  };
  return <SketchPicker color={formik.values.coverBgColor} onChangeComplete={handleChange} />;
}
